module.exports = __webpack_public_path__ + "static/media/O.d83c0f04.png";